export const TIME__DATE_AND_TIME = "yyyy-MM-dd HH:mm:ss";
export const TIME__DATE = "yyyy-MM-dd";
export const API_HOST =
process.env.REACT_APP_ENV === "local"
  ? `http://${window.location.hostname}:8005`
  : `https://${window.location.hostname}`;
